/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 12:24:55 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import * as Theme from 'theme';
import { Chip } from '@material-ui/core';

function desaturate(hexColour) {
  return `${hexColour}50`;
}

const useStyles = makeStyles({
  accepted: {
    margin: 2,
    backgroundColor: desaturate(Theme.darkenedGreen),
  },
  pending: {
    margin: 2,
    backgroundColor: desaturate(Theme.darkenedAmber),
  },
  rejected: {
    margin: 2,
    backgroundColor: desaturate(Theme.darkenedRed),
  },
});

const FilteredEmploymentProjectOrganisationField = ({ record, source }) => {
  const classes = useStyles();
  const translate = useTranslate();

  if (source && record && record[source] && record[source].length > 0) {
    return record[source].map(item => {
      const statusKey = item.status.toLowerCase();
      const statusLabel = translate(
        `resources.Employment.fields.${statusKey}Status`
      );
      const isPending = item.status === 'PENDING';
      return (
        <Chip
          key={`${item.id}-${source}`}
          className={classes[statusKey]}
          label={`${item.name}${statusLabel}`}
        />
      );
    });
  }
  return 'N/A';
};

export default FilteredEmploymentProjectOrganisationField;
